'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import { forwardRef } from 'react';
import Link from '@mui/material/Link';
import { useHeaderState } from './HeaderStateContext';
import { excludeComponentProps } from '../utils/excludeComponentProps';
import { headerCssClassNames } from './headerCssClassNames';
import clsx from 'clsx';
const StyledHeaderAppend = styled('div', {
    ...excludeComponentProps('breakpoint', 'brandFontStack')
})(({ theme, brandFontStack }) => ({
    height: 'var(--header-append-height)',
    lineHeight: 'var(--header-append-height)',
    backgroundColor: '#fff',
    paddingInline: theme.tokens.FuelSpacing4,
    position: 'relative',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    borderBottom: `solid 1px ${theme.tokens.FuelColorBorderLight}`,
    gridArea: 'header-append',
    zIndex: 1,
    '& .HeaderAppend-text': {
        fontSize: theme.tokens.FuelFontSizeBase,
        textDecoration: 'none',
        color: theme.tokens.FuelColorBrandPrimary,
        textOverflow: 'ellipsis',
        ...brandFontStack === 'jdSans' && {
            fontFamily: theme.tokens.FuelFontFamilyJdSansProMedium,
            fontSize: theme.tokens.FuelFontSizeHeading3
        },
        '&.HeaderAppend-link:hover': {
            color: theme.tokens.FuelColorTextLinkHovered
        }
    }
}));
export const HeaderAppend = forwardRef((_, ref) => {
    const { title, titleLink, brandFontStack } = useHeaderState();
    return (_jsx(StyledHeaderAppend, { brandFontStack: brandFontStack, className: headerCssClassNames.append, ref: ref, children: _jsx(Link, { className: clsx(headerCssClassNames.appendLink, 'HeaderAppend-text', 'HeaderAppend-link'), href: titleLink, children: title }) }));
});
HeaderAppend.displayName = 'HeaderAppend';
